import { Component, OnInit } from '@angular/core';
import { InsuranceService } from '../Services/insurance-service.service';
import { Router } from '@angular/router';
import { InsuranceRights, InsuranceRightsObject, RootResponse } from '../Models/TravelInsuranceProperties';
import { NgForm, FormsModule } from '@angular/forms';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { FlightSearchProperties } from '../Models/FlightSearchProperties';
import { MessageService } from 'primeng/api';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { Dialog } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';

@Component({
    selector: 'app-travel-insurance-plan-results',
    templateUrl: './travel-insurance-plan-results.component.html',
    styleUrls: ['./travel-insurance-plan-results.component.css'],
    imports: [NavMenuComponent, Bind, Drawer, Dialog, FormsModule, InputText]
})
export class TravelInsurancePlanResultsComponent implements OnInit {

  constructor(public insurance: InsuranceService, public router: Router, private messageservIce: MessageService) { }
  genericReqData: any;
  RightsObj: InsuranceRightsObject = new InsuranceRightsObject();
  resultLoader: boolean = true;
  ngOnInit() {
    this.resultLoader = true;
    this.genericReqData = localStorage.getItem('TravelInsuranceRequestObj');
    this.genericReqData = JSON.parse(this.genericReqData);
    if (this.genericReqData.requestType == "oneway") {
      this.OnewayAvailability();
    } else {
      this.RoundTripAvailability();
    }
  }
  genericResponse: RootResponse;
  flightSearchObj: FlightSearchProperties = new FlightSearchProperties();
  OnewayAvailability() {
    this.resultLoader = true;
    let reqData = new FormData();
    reqData.append("countryCode", this.genericReqData.countryCode);
    reqData.append("totalAdults", this.genericReqData.totalAdults);
    reqData.append("totalChild", this.genericReqData.totalChild);
    reqData.append("totalInfants", this.genericReqData.totalInfants);
    reqData.append("departCountryCode", this.genericReqData.departCountryCode);
    reqData.append("arrivalCountryCode", this.genericReqData.arrivalCountryCode);
    reqData.append("departDateTime", this.genericReqData.departDateTime);
    reqData.append("parentHierarchy", localStorage.getItem("ParentHierarchy"));
    reqData.append("agencyId", localStorage.getItem("AgencyId"));
    reqData.append("flightLocationCount", String(1));

    let scrollableDiv = document.getElementById('resultsSection') as HTMLDivElement;
    let bottomElement = scrollableDiv.lastElementChild;
    bottomElement.scrollIntoView({ behavior: 'smooth', block: 'end' });

    this.insurance.GetPlansAvailability(reqData).subscribe(data => {
      const resp = data;
      this.genericResponse = resp;
      this.resultLoader = false;
      this.GetInsuranceRight(this.genericResponse.supplierId, this.genericResponse.officeId);

    });
  }
  RoundTripAvailability() {
    this.resultLoader = true;
    let reqData = new FormData();
    reqData.append("countryCode", this.genericReqData.countryCode);
    reqData.append("totalAdults", this.genericReqData.totalAdults);
    reqData.append("totalChild", this.genericReqData.totalChild);
    reqData.append("totalInfants", this.genericReqData.totalInfants);
    reqData.append("departCountryCode", this.genericReqData.departCountryCode);
    reqData.append("arrivalCountryCode", this.genericReqData.arrivalCountryCode);
    reqData.append("departDateTime", this.genericReqData.departDateTime);
    reqData.append("returnDateTime", this.genericReqData.returnDateTime);
    reqData.append("parentHierarchy", localStorage.getItem("ParentHierarchy"));
    reqData.append("agencyId", localStorage.getItem("AgencyId"));
    reqData.append("flightLocationCount", String(2));

    let scrollableDiv = document.getElementById('resultsSection') as HTMLDivElement;
    let bottomElement = scrollableDiv.lastElementChild;
    bottomElement.scrollIntoView({ behavior: 'smooth', block: 'end' });

    this.insurance.GetPlansAvailability(reqData).subscribe(data => {
      const resp = data;
      this.genericResponse = resp;
      this.GetInsuranceRight(this.genericResponse.supplierId, this.genericResponse.officeId);

      this.resultLoader = false;
    });
  }
  planDetailsVisible0: boolean = false;
  toPlanSearch() {
    this.router.navigateByUrl('insurance-issuance');
  }
  planTitle: string = "";
  planType: string = "";
  currencyCode: string = "";
  totalPremium: number = 0;
  planContent: string = "";
  plan: any;
  planWithoutRevenue: any;
  previousIndex: number = 0;
  planDetailsDisplay(plan: any, index: number) {
    this.currencyCode = plan.currencyCode;
    this.planTitle = plan.planTitle;
    this.planType = plan.planType;
    this.totalPremium = plan.totalPremiumAmount;
    this.planContent = plan.planContent;
    this.plan = plan;
    let preDiv = document.getElementById("solution_card" + this.previousIndex) as HTMLDivElement;
    preDiv.style.backgroundColor = "#FFF";
    let div = document.getElementById("solution_card" + index) as HTMLDivElement;
    div.style.backgroundColor = "#FFAA00";
    this.previousIndex = index;
    this.planDetailsVisible0 = true;
  }
  insuranceRight = new InsuranceRights();
  GetInsuranceRight(supplierid, officeid) {
    this.RightsObj.agencyId = String(localStorage.getItem("AgencyId"));
    this.RightsObj.userId = Number(localStorage.getItem("UserId")).toString();
    this.RightsObj.supplierid = supplierid;
    this.RightsObj.officeid = officeid;
    this.insurance.CheckRightsInsurance(this.RightsObj).subscribe(data => {
      this.insuranceRight = data;
      localStorage.setItem("InsuranceIssueRights", JSON.stringify(this.insuranceRight));
    });
  }
  toPassengersDetails() {
    if (!this.insuranceRight.book) {
      this.messageservIce.add({ severity: 'error', summary: 'Rejected', detail: 'You have no Right to Book!' });

      return;
    }
    for (let p = 0; p < this.genericResponse.genericResponse.availablePlans.length; p++) {
      if (this.plan.planCode === this.genericResponse.genericResponse.availablePlans[p].planCode && this.plan.ssrFeeCode === this.genericResponse.genericResponse.availablePlans[p].ssrFeeCode) {
        this.planWithoutRevenue = this.genericResponse.genericResponse.availablePlans[p];
      }
    }
    localStorage.setItem('selectedPlan', JSON.stringify(this.plan));
    localStorage.setItem('selectedPlanWithoutRevenue', JSON.stringify(this.planWithoutRevenue));
    this.router.navigateByUrl('insured-passengers');
  }

  displayEmail: boolean = false;
  showDialog() {
    this.displayEmail = true;
  }
  emailAddress: string = "";
  customerName: string = "";
  emailPlan() {
    this.resultLoader = true;
    let emailObj = new EmailItineraryProperties();
    emailObj.customerEmail = this.emailAddress;
    emailObj.customerName = this.customerName;
    emailObj.subject = "Your Selected Travel Insurance Plan's Quotation";
    emailObj.body = `
      <div style = "border: 1px solid #0F5D62;padding:25px" >
        <p style="text-align:center">Note: This is a system generated message. We request you not to reply to this message.</p>
        <div style="background-color:#FFAA00;">
           <h2 style="padding-top:10px;padding-bottom:10px;color:#fff;font-weight:700;text-align:center"> Plan Quotation</h2>
        </div>
        <p style="padding-left:20px"> Dear <b>${emailObj.customerName}</b>,</p><br/>
        <p style="padding-left:20px"> &emsp; &emsp; &emsp; We are pleased to send you the requested quotation.</p><br/>
        <p style="padding-left:20px;margin-top:30px;margin-bottom:20px">&emsp; &emsp; &emsp; Plan Title: &emsp; <b>${this.planTitle}</b></p>
        <div>${this.planContent}</div>
        <p style="padding-left:40px;margin-top:40px">&emsp; &emsp; &emsp;<b>${this.plan.currencyCode}${this.plan.totalPremiumAmount}</b></p>
      <div style="padding-left:20px;margin-top:20px"> For More Information or Assistance Please Call Us! <br/> <b  style="font-size:10px;margin-top:20px;t" > Phone: </b> +971 333 123 456 7    <b>Email:</b > info@oktravels.com </div>
`;
    this.insurance.EmailPlanQuote(emailObj).subscribe(data => {
      this.resultLoader = false;
      const resp = data;
      this.genericResponse = resp;
    });
    this.displayEmail = false;
  }
}
